module.exports = __webpack_public_path__ + "8316d4980635c5700a9ac10c2913a2aa.svg";